import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Truck } from "@/components/icons";
import { useAuth } from "@/context/AuthContext";
import { getErrorMessage } from "@/lib/errors";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const user = await login(email.trim(), password);
      if (user.must_change_password) {
        navigate("/wachtwoord-wijzigen", { replace: true });
      } else {
        navigate("/dashboard", { replace: true });
      }
    } catch (err) {
      setError(getErrorMessage(err, "Inloggen mislukt. Probeer opnieuw."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4">
      <Card className="w-full max-w-md p-8">
        <div className="mb-6 flex items-center gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-md bg-primary text-primary-foreground">
            <Truck size={20} />
          </div>
          <div>
            <div className="text-kop font-semibold text-foreground">TD-Ops</div>
            <div className="text-data text-muted-foreground">TW1 Group</div>
          </div>
        </div>
        <h2 className="mb-1 text-kop font-semibold text-foreground">Inloggen</h2>
        <p className="mb-6 text-body text-muted-foreground">
          Log in met je e-mailadres en wachtwoord.
        </p>

        <form onSubmit={onSubmit} className="space-y-4">
          <div className="space-y-1.5">
            <Label htmlFor="email">E-mailadres</Label>
            <Input
              id="email"
              type="email"
              autoComplete="username"
              data-testid="login-email-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="naam@truckwash1group.nl"
              required
            />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="password">Wachtwoord</Label>
            <Input
              id="password"
              type="password"
              autoComplete="current-password"
              data-testid="login-password-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          {error && (
            <p
              data-testid="login-error-text"
              aria-live="polite"
              className="text-data text-destructive"
            >
              {error}
            </p>
          )}

          <Button
            type="submit"
            data-testid="login-submit-button"
            className="w-full"
            disabled={loading}
          >
            {loading ? "Bezig..." : "Inloggen"}
          </Button>
        </form>
      </Card>
    </div>
  );
}
